import { useQuery } from '@tanstack/react-query';
import { expertDashboardApi } from '../lib/http';
import type { CalendarView } from '../types';
import { format } from 'date-fns';

export function useCalendar(
  viewMode: 'day' | 'week' | 'month',
  date: Date,
  timezone?: string
) {
  const dateStr = format(date, 'yyyy-MM-dd');

  return useQuery<CalendarView>({
    queryKey: ['calendar', viewMode, dateStr, timezone],
    queryFn: async () => {
      const response = await expertDashboardApi.calendar.getAvailability({
        view_mode: viewMode,
        date: dateStr,
        timezone,
      });
      return response.data;
    },
    staleTime: 1000 * 60, // 1 minute
    refetchOnWindowFocus: true,
  });
}
